import './NoPage.css'

export default function NoPage(){
  return(
    <div>
   <title>Error</title>
    <h2>Error 404: Not Found</h2>
    </div>
  )
}